<template>
	<div style="font-family: -apple-system-font ,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
		<div class="carousel">
			案例精选
		</div>
		<div class="case_main">
			<div class="case_top">
				<div class="case_title">茅台酒糟智能管控系统</div>
				<div class="case_time">
					<img src="../../assets/images/developerCommunity/dev_time.png" alt="">
					<span>2020/06/12</span>
				</div>
				<hr>
			</div>
			<div class="case_detail">
				<div class="model">
					<div class="model_title">【企业介绍】</div>
					<div class="section">
						通过3D场景，借助数据采集、仿真模拟等技术，以三维直观的方式将工厂、设备、产线等信息融合进工厂的3D全息图景中，从而实现园区建筑、内部环境以及产线流程的虚拟现实仿真，重点突出生态经济循环产业园在循环上的特点。
					</div>
				</div>
				<div class="model">
					<div class="model_title">【项目概况】</div>
					<div class="section">
						<img src="../../assets/images/detail_pic4.png" alt="">
					</div>
					<div class="section">
						智能管控系统包含以下功能：智能维保、智能安防、智能报表、运营看板、3D管控、数据分析。利用3D可视化技术、快速建模技术等，集成工厂内设备及传感器、视频监控、人员定位等信息，实现厂区生产、安防、巡检等可视化的管理。
					</div>
				</div>
				<div class="model">
					<div class="model_title">【项目效果】</div>
					<div class="section">
						通过研究茅台酒糟项目工艺流程、设备特点，通过现场调研和现有云平台功能实现评估，根据过程对接明确的使用需求，利用物联网、大数据、云计算等技术，对设备进行智能化升级改造，搭建智能管控平台，对生产数据实时监测和及时分析，利用数据报表和优化模型等手段，保障生产运行安全稳定、降低运营成本、提高项目整体效益。
					</div>
					<div class="section">
						增加一套智能管控系统解决当前存在的自动化不足的问题，同时增加能耗、增效等方面的分析，还增加自动报表的输出，为厂区的运营监管提供智能服务。
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'CaseZjnznhDetail',
		data() {
			return {
				detailId: this.$route.params.id,
			}
		},
		mounted() {
			window.scrollTo(0, 0)
			this.init()
		},
		methods: {
			init() {
				console.log(this.detailId)
			}
		}
	}
</script>

<style lang="scss">
	.carousel {
		background-color: #1a1a1a;
		height: 4rem;
		text-align: center;
		line-height: 4rem;
		font-size: 0.4rem;
		color: #FFFFFF;
	}

	.case_main {

		padding: 0 2.4rem;
		margin-bottom: 0.3rem;

		.case_top {
			margin-top: 0.6rem;

			.case_title {
				font-size: 0.32rem;
			}

			.case_time {
				margin-top: 0.2rem;
				font-size: 0.18rem;
				color: #999999;
				display: flex;
				align-items: center;

				img {
					width: 0.2rem;
					height: 0.2rem;
					margin-right: 0.1rem;
				}
			}

			hr {
				margin-top: 0.4rem;
				color: #cccccc;
			}
		}

		.case_detail {
			margin: 0 2.2rem;
			margin-bottom: 0.6rem;
			color: #000000;

			img {
				width: 100%;
			}

			.model {
				margin-top: 0.2rem;

				.model_title {
					font-size: 0.22rem;
					font-weight: 600;
				}

				.section {
					padding-left: 0.12rem;
					text-indent: 2em;
					line-height: 0.36rem;
					font-size: 0.18rem;
					margin-top: 0.12rem;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseZjnznhDetail.vue